import clsx from "clsx";
import shape from "../../assets/img/shapes/book-shape-01.webp";


const BookShape01 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-book-shape-01", props.className)}>
            <img src={shape} alt="rmdr-book-shape-01" loading="lazy" width={70} height={70} />
        </div>
    )

}

export default BookShape01;
